var map = {
	"./bmp": 596,
	"./bmp.js": 596,
	"./gif": 597,
	"./gif.js": 597,
	"./jpg": 598,
	"./jpg.js": 598,
	"./png": 599,
	"./png.js": 599,
	"./psd": 600,
	"./psd.js": 600,
	"./svg": 601,
	"./svg.js": 601,
	"./tiff": 602,
	"./tiff.js": 602,
	"./webp": 603,
	"./webp.js": 603
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 594
// module chunks = 1